module.exports = __webpack_public_path__ + "static/media/less5-icon.a6d77e5a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onboard/less5-icon.svg
// module id = 2871
// module chunks = 0